module.exports = __webpack_public_path__ + "img/team-band.4a47e996.jpg";